import { PiPianoKeysFill } from 'react-icons/pi';
import { useState, useEffect } from 'react';
import MidiHelper from './MidiHelper';
import { useManagerEntity } from '@/shared/managerHelpers';
import { observer } from 'mobx-react';
import { midiStore } from '@/stores/midiStore';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import { useTranslation } from 'react-i18next';

const MidiStatus = observer(() => {
  const [open, setOpen] = useState(false);
  const [showHelp, setShowHelp] = useState(true);
  const [dontShow, setDontShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const managerEntity = useManagerEntity();
  const { t } = useTranslation();

  const isMidiDisconnected = (inputId: any, inputs: any[]) =>
    !inputId || !inputs.some((input) => input.id === inputId);

  const midiDisconnected =
    !managerEntity?.midiManager ||
    isMidiDisconnected(managerEntity.midiManager.inputId, midiStore.inputs);

  console.log('###midiManager:', managerEntity?.midiManager);
  console.log('###inputId:', managerEntity?.midiManager?.inputId);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setDontShow(localStorage.getItem('midiStatusDontShow') === 'true');
      // Detect all Apple devices (iOS, macOS, Safari)
      const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isMacOS = /Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.userAgent);
      const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      setIsIOS(isIOSDevice || isMacOS || isSafari);
    }
  }, []);

  useEffect(() => {
    if (dontShow) setShowHelp(false);
    else setShowHelp(true);
  }, [dontShow]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (neverShowAgain: boolean) => {
    setOpen(false);
    if (neverShowAgain && typeof window !== 'undefined') {
      localStorage.setItem('midiStatusDontShow', 'true');
      setDontShow(true);
    }
  };


  return (
    <>
      {midiDisconnected && showHelp && !dontShow && !isIOS && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={handleOpen}
                className='fixed bottom-38 right-4 z-50 flex items-center bg-yellow-400 p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group overflow-hidden'
                style={{
                  width: '56px', // 14 * 4 = 56px (icon + padding)
                  height: '56px',
                  transition: 'width 0.3s, box-shadow 0.3s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.width = '220px')}
                onMouseLeave={(e) => (e.currentTarget.style.width = '56px')}
              >
                <span className='relative flex items-center justify-center w-full h-full'>
                  <PiPianoKeysFill size={28} />
                  <span
                    style={{
                      position: 'absolute',
                      left: 4,
                      top: 10,
                      width: 20,
                      height: 2,
                      background: 'black',
                      transform: 'rotate(-30deg)',
                      pointerEvents: 'none',
                    }}
                  />
                </span>
                {/* Text slides in from the right on hover */}
                <span
                  className='ml-2 text-sm font-medium opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 cursor-pointer'
                  style={{
                    whiteSpace: 'nowrap',
                    transition: 'opacity 0.3s, transform 0.3s',
                  }}
                  suppressHydrationWarning
                >
                  {t('midiStatus.where_is_keyboard')}
                </span>
              </button>
            </TooltipTrigger>
            <TooltipContent variant='zinc' side='top' className='text-xs mr-2' suppressHydrationWarning>
              {t('midiStatus.not_connected')}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      <MidiHelper
        managerEntity={managerEntity}
        forceOpen={open}
        onClose={handleClose}
        isIOS={isIOS}
      />
    </>
  );
});

export default MidiStatus;